// A Gmail compose link, so reaching out to a church's administrator during the huddle is one click
// rather than a copy, a tab switch and a paste.
//
// Recipient and subject only: the huddle is where the note gets written, and prefilling a body would
// be putting words in the writer's mouth.  Gmail's own parameter names - `view=cm` for compose mode,
// `fs=1` for full screen, `su` for subject.
const gmailComposeBaseUrl = 'https://mail.google.com/mail/?view=cm&fs=1';

export function gmailComposeUrl({ to, subject }: { to: string; subject: string }): string {
  // both are user data - an org name can hold an ampersand, which would otherwise start a new query
  // parameter, and the em dash in the subject is not URL-safe either
  return `${gmailComposeBaseUrl}&to=${encodeURIComponent(to)}&su=${encodeURIComponent(subject)}`;
}

// e.g. "Sing Your Part — Grace Church"
export function huddleEmailSubject(orgName: string): string {
  return `Sing Your Part — ${orgName}`;
}
